import { useCallback, useEffect, useState } from "react";
import {
  createPatApiToken,
  listPatApiTokens,
  revokePatApiToken,
  rotatePatApiToken,
} from "../common/apiClient";

export function useApiAccessTokens() {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const items = await listPatApiTokens();
      setTokens(items);
    } catch (err) {
      setError(err.message || "Error al cargar tokens");
      setTokens([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh().catch(() => {});
  }, [refresh]);

  const createToken = useCallback(
    async (input) => {
      const result = await createPatApiToken(input);
      await refresh();
      return result;
    },
    [refresh]
  );

  const revokeToken = useCallback(
    async (patId) => {
      await revokePatApiToken(patId);
      await refresh();
    },
    [refresh]
  );

  const rotateToken = useCallback(
    async (patId) => {
      const result = await rotatePatApiToken(patId);
      await refresh();
      return result;
    },
    [refresh]
  );

  return { tokens, loading, error, refresh, createToken, revokeToken, rotateToken };
}
